import { createSelector } from 'reselect';

const formFor = state => state.department.formFor;
const list = state => state.department.forms;

const selectedFormFor = createSelector(
  [formFor, list],
  (type, forms) => {
    const formForType = !forms ? null : forms.find(form => form.type === type);
    return !formForType ? null : formForType;
  },
);

export default { selectedFormFor };
